import { render, staticRenderFns } from "./loading-popup.vue?vue&type=template&id=6159d9e6&scoped=true&"
import script from "./loading-popup.vue?vue&type=script&lang=js&"
export * from "./loading-popup.vue?vue&type=script&lang=js&"
import style0 from "./loading-popup.vue?vue&type=style&index=0&id=6159d9e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6159d9e6",
  null
  
)

export default component.exports